import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/EventCard.css';

const EventCard = ({ event, showStatus = false, viewMode = 'grid' }) => {
  const eventTypeLabels = {
    faescht:  'Fäscht',
    fasnacht: 'Fasnacht',
    sport:    'Sport',
    bar:      'Bar',
    club:     'Club',
    konzert:  'Konzert',
    kultur:   'Kultur',
    sonstige: 'Sonstige',
    // legacy
    concert: 'Konzert', festival: 'Festival', sports: 'Sport',
    exhibition: 'Ausstellung', theater: 'Theater', workshop: 'Workshop',
    conference: 'Konferenz', party: 'Party', other: 'Andere'
  };

  const statusIcons = {
    approved: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    ),
    pending: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <polyline points="12 6 12 12 16 14"></polyline>
      </svg>
    ),
    rejected: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    )
  };

  const statusTitles = {
    pending: 'Genehmigung ausstehend',
    approved: 'Genehmigt',
    rejected: 'Abgelehnt'
  };

  return (
    <Link to={`/event/${event._id}`} className={`event-card ${viewMode === 'list' ? 'list-view' : ''}`}>
      <div className="event-card-image">
        {event.bannerImage ? (
          <img src={event.bannerImage} alt={event.title} />
        ) : (
          <div className="placeholder-image">
            <span className="placeholder-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
            </span>
            <span className="placeholder-text">Kein Bild verfügbar</span>
          </div>
        )}
        {showStatus && event.status && (
          <div className={`event-status-badge icon-only ${event.status}`} title={statusTitles[event.status]}>
            {statusIcons[event.status]}
          </div>
        )}
      </div>
      <div className="event-card-content">
        <h3>{event.title}</h3>
        <div className="event-card-info">
          <div className="info-row">
            <span className="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
            </span>
            <span>{new Date(event.startDate).toLocaleDateString('de-CH')}</span>
          </div>
          <div className="info-row">
            <span className="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
            </span>
            <span>{event.location}, {event.canton}</span>
          </div>
          <div className="info-row">
            <span className="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                <line x1="7" y1="7" x2="7.01" y2="7"></line>
              </svg>
            </span>
            <span>{eventTypeLabels[event.eventType] || (event.eventType ? event.eventType.charAt(0).toUpperCase() + event.eventType.slice(1) : '')}</span>
          </div>
          <div className="info-row">
            <span className="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="1" x2="12" y2="23"></line>
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
              </svg>
            </span>
            <span>{event.price}</span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default EventCard;
